import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ProductsService } from '../products.service';
import { MaintainProductComponent } from '../maintain-products/maintain-product.component';
import { map, Observable, take } from 'rxjs';
import { AddEvent, DataStateChangeEvent, GridComponent, GridDataResult } from '@progress/kendo-angular-grid';
import { State, process, CompositeFilterDescriptor, filterBy } from "@progress/kendo-data-query";
import { ReOrderProductComponent } from '../reorder-products/reorder-product.component';
import { GetProductsQueryResponse, GetProductQueryResponse, CreateProductCommand } from '../../interfaces/interfaces';

@Component({
  selector: 'sdc-list-products',
  templateUrl: './list-products.component.html',
  styleUrls: ['./list-products.component.scss']
})
export class ListProductComponent implements OnInit {

  jewelleryForm: UntypedFormGroup;
  isLoading = false;
  canEdit = false;
  chosenJewellery: GetProductsQueryResponse;
  jewelleries = [];
  userName: string;
  role: string;

  
  public filter: CompositeFilterDescriptor = {
    logic: "and",
    filters: [],
  };
  public newDataItem: CreateProductCommand;
  public editDataItem: GetProductQueryResponse;
  public isNew: boolean;
  public jewellery: GetProductQueryResponse;
  products: GetProductQueryResponse[] = [];

  
  public gridState: State = {
    sort: [],
    skip: 0,
    take: 15,
  };
  public gridStateAlert: State = {
    sort: [],
    skip: 0,
    take: 15,
  };
  public gridStateWarning: State = {
    sort: [],
    skip: 0,
    take: 15,
  };
  //public gridData: Observable<any>;
  public gridDataAlert: Observable<any>;
  public gridDataWarning: Observable<any>;
  public gridData: any = process(this.products, this.gridState);

  constructor(
    private dialog: MatDialog,
    private jewelleryService: ProductsService,
  ) { }

  ngOnInit(): void {
    this.canEdit = true;
    this.userName = JSON.parse(localStorage.getItem('currentUser')).userName;
    this.role = JSON.parse(localStorage.getItem('currentUser')).role;
    //this.role = localStorage.getitem('currentRole');
    this.intialiseData();
  }

  public dataStateChange(state: DataStateChangeEvent): void {
    this.gridState = state;
    //this.gridData = process(this.products, this.gridState);
    this.gridData = this.jewelleryService.getAllProducts().pipe(
      map((data) => process(data.products, this.gridState))
    );
  }

  public dataStateChangeAlert(state: DataStateChangeEvent): void {
    this.gridStateAlert = state;
    //this.gridData = process(this.products, this.gridState);
    this.gridDataAlert = this.jewelleryService.getProductAlerts().pipe(
      map((data) => process(data.products, this.gridStateAlert))
    );
  }

  public dataStateChangeWarning(state: DataStateChangeEvent): void {
    this.gridStateWarning = state;
    //this.gridData = process(this.products, this.gridState);
    this.gridDataWarning = this.jewelleryService.getProductsWarnings().pipe(
      map((data) => process(data.products, this.gridStateWarning))
    );
  }

  public addHandler(): void {
    this.editDataItem.id = 0; //new this.editDataItem();
    this.isNew = true;
  }

  public editHandler(args: AddEvent): void {
    this.editDataItem = args.dataItem;
    this.isNew = false;
  }

  public cancelHandler(): void {
    this.editDataItem = undefined;
  }

  public saveHandler(product: GetProductQueryResponse): void {
    this.editDataItem = undefined;
  }

  intialiseData(): void {

    //alert("Initialise");
    if (this.role == 'Stock')
    {
      this.gridData = this.jewelleryService.getAllProducts().pipe(
        map((data) => process(data.products, this.gridState))
      );
      //this.gridData = this.jewelleryService.apiProductGet().pipe(
      //  map((data) => process(data.products.filter(x => x.store == 'DISHD'), this.gridState))
      //);
    }
    else if (this.role == 'Creams')
    {
      this.gridData = this.jewelleryService.getAllProducts().pipe(
        map((data) => process(data.products, this.gridState))
      );
    }
    else {
      this.gridData = this.jewelleryService.getAllProducts().pipe(
        map((data) => process(data.products, this.gridState))
      );
    }

    this.gridDataAlert = this.jewelleryService.getProductAlerts().pipe(
      map((data) => process(data.products, this.gridStateAlert))
    );

    this.gridDataWarning = this.jewelleryService.getProductsWarnings().pipe(
      map((data) => process(data.products, this.gridStateWarning))
    );
    
    this.jewelleryService.getAllProducts().pipe(take(1)).subscribe({
      next: (response: GetProductsQueryResponse) => {
        //alert(this.role);
        if (this.role == 'Stock')
        {
          //console.log(response);
          //response.products = response.products.filter(x => x.store == 'DISHD');
          //console.log(response);
        }
        this.chosenJewellery = response;
        //this.products = this.chosenJewellery.products;

        //console.log(this.chosenJewellery);
        //this.gridData = process(this.chosenJewellery.products, this.gridState);
        //alert("in next");
        //this.jewelleries = response.products.map((data) => ({
        //  id: data.id,
        //  title: data.title,
        //}));
        //console.log(this.gridData);
        this.isLoading = false;
      },
      error: (error: HttpErrorResponse) => {
        //alert(error);
        this.isLoading = false;
      }
    });
  }

  createJewellery(): void {

    const dialogRef = this.dialog.open(MaintainProductComponent, {
      width: '1300px',
      data: {
        id: 0,
      },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(() => {
      this.intialiseData();
    });
  }

  updateJewellery(args: AddEvent): void {
    var sid = args.dataItem.id;
    this.jewellery = this.chosenJewellery.products.find(x => x.id === sid);
    console.log(this.jewellery);
    const dialogRef = this.dialog.open(MaintainProductComponent, {
      width: '1300px',
      data: this.jewellery,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(() => {
      this.intialiseData();
    });
  }

  reOrderProduct(args: AddEvent): void {
    var sid = args.dataItem.id;
    this.jewellery = this.chosenJewellery.products.find(x => x.id === sid);
    //alert(this.jewellery.description);
    const dialogRef = this.dialog.open(ReOrderProductComponent, {
      width: '1300px',
      data: this.jewellery,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(() => {
      this.intialiseData();
    });
  }
  
}
